// extracted by mini-css-extract-plugin
module.exports = {"lobbyPage":"style_lobbyPage__13am8","smallLogo":"style_smallLogo__2HGMt","githubLink":"style_githubLink__1Uify"};